import { render, staticRenderFns } from "./ArticleContentYjjM.vue?vue&type=template&id=0e6842dc&scoped=true&"
import script from "./ArticleContentYjjM.vue?vue&type=script&lang=js&"
export * from "./ArticleContentYjjM.vue?vue&type=script&lang=js&"
import style0 from "./ArticleContentYjjM.vue?vue&type=style&index=0&id=0e6842dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6842dc",
  null
  
)

export default component.exports